import { type FC } from 'react';
import classnames from 'classnames';

import HeartFilled from './HeartFilled';
import Favorite from '../Favorite';

import styles from './styles/LikeHeartIcon.scss';

type LikeHeartIconProps = {
    className?: string;
    isFilled?: boolean;
    animateHeartBeat?: boolean;
    theme?:
        | 'dark'
        | 'light'
        | 'circle-light'
        | 'circle-frosted-small'
        | 'circle-frosted-medium'
        | 'circle-frosted-large';
};

const LikeHeartIcon: FC<LikeHeartIconProps> = ({
    className,
    animateHeartBeat,
    isFilled,
    theme,
}) => {
    const isCircleFrostedSmall = theme === 'circle-frosted-small';
    const isCircleFrostedMedium = theme === 'circle-frosted-medium';
    const isCircleFrostedLarge = theme === 'circle-frosted-large';
    const isCircleFrosted = isCircleFrostedSmall || isCircleFrostedMedium || isCircleFrostedLarge;
    const iconClasses = classnames(className, styles.likeIcon, {
        [styles.showHeartBeat]: animateHeartBeat,
        [styles.isFilled]: isFilled,
        [styles.dark]: theme === 'dark',
        [styles.light]: theme === 'light',
        [styles.circleLight]: theme === 'circle-light',
        [styles.circleFrosted]: isCircleFrosted,
    });

    if (isCircleFrosted) {
        let variation;
        if (isCircleFrostedSmall && isFilled) {
            variation = '20Filled' as const;
        } else if (isCircleFrostedSmall && !isFilled) {
            variation = '20' as const;
        } else if (!isCircleFrostedSmall && isFilled) {
            variation = '24Filled' as const;
        } else if (!isCircleFrostedSmall && !isFilled) {
            variation = '24' as const;
        } else {
            return null;
        }
        return (
            <span className={iconClasses}>
                <Favorite variation={variation} />
            </span>
        );
    }

    return <HeartFilled className={iconClasses} />;
};
export default LikeHeartIcon;
